import React from 'react';

const AllianceResearch = () => {
  return <h1>AllianceResearch Page</h1>;
};

export default AllianceResearch;
